export default {
	portfolio: state => state.portfolio,
	selfDirectedPortfolioId: state => {
		if (!_.isEmpty(state.portfolio)) {
			const tempPortfolio = state.portfolio.find(_portfolio => _portfolio.portfolio_type_id === 1)

			return tempPortfolio?.external_portfolio_id
		}

		return null
	},
	liquidityPortfolioId: state => {
		if (!_.isEmpty(state.portfolio)) {
			const tempPortfolio = state.portfolio.find(_portfolio => _portfolio.portfolio_type_id === 2)

			return tempPortfolio?.external_portfolio_id
		}
		return null
	},
	customPortfolios: state => {
		return state.portfolio.filter(_portfolio => _portfolio.portfolio_type_id === 8)
	},
	liquidityPortfolio: state => {
		return state.portfolio.filter(_portfolio => _portfolio.portfolio_type_id === 2)
	},
	selfDirectedPortfolio: state => {
		return state.portfolio.filter(_portfolio => _portfolio.portfolio_type_id === 1)
	},
}
